/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_DescriptionInputs */

const en_cargos_description = /** @type {(inputs: Cargos_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse inventory with real-time availability tracking.`)
};

const es_cargos_description = /** @type {(inputs: Cargos_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventario de almacen con seguimiento de disponibilidad en tiempo real.`)
};

/**
* | output |
* | --- |
* | "Warehouse inventory with real-time availability tracking." |
*
* @param {Cargos_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_description = /** @type {((inputs?: Cargos_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_description(inputs)
	return es_cargos_description(inputs)
});